import { PERMISSION_GROUPS } from "@/constants/permissions";
import type { PermissionKey } from "@/types";

interface PermissionChecklistProps {
  value: PermissionKey[];
  onChange: (next: PermissionKey[]) => void;
}

export default function PermissionChecklist({
  value,
  onChange,
}: PermissionChecklistProps) {
  const toggle = (key: PermissionKey) => {
    onChange(
      value.includes(key)
        ? value.filter((item) => item !== key)
        : [...value, key],
    );
  };

  return (
    <div className="space-y-3">
      {PERMISSION_GROUPS.map((group) => {
        const selectedCount = group.permissions.filter((permission) =>
          value.includes(permission.key),
        ).length;
        return (
          <div
            key={group.key}
            className="rounded-box border border-background-200 overflow-hidden"
          >
            <div className="flex items-center justify-between gap-2 px-4 py-3 bg-background-50 border-b border-background-100">
              <div className="flex items-center gap-2.5">
                <span
                  className={`w-8 h-8 flex items-center justify-center rounded-full ${group.tone}`}
                >
                  <i className={group.icon}></i>
                </span>
                <h4 className="text-sm font-bold text-foreground-950">
                  {group.label}
                </h4>
              </div>
              <span className="text-xs font-medium text-foreground-500">
                {selectedCount}/{group.permissions.length}
              </span>
            </div>
            <ul className="divide-y divide-background-100">
              {group.permissions.map((permission) => {
                const checked = value.includes(permission.key);
                return (
                  <li key={permission.key}>
                    <label className="flex items-start gap-3 px-4 py-3 cursor-pointer hover:bg-background-50 transition-colors duration-200">
                      <input
                        type="checkbox"
                        className="hidden"
                        checked={checked}
                        onChange={() => toggle(permission.key)}
                      />
                      <span
                        className={`mt-0.5 w-5 h-5 shrink-0 flex items-center justify-center rounded-md border transition-colors duration-200 ${
                          checked
                            ? "bg-primary-500 border-primary-500 text-white"
                            : "bg-white border-background-200 text-transparent"
                        }`}
                      >
                        <i className="ri-check-line text-sm"></i>
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block text-sm font-medium text-foreground-900">
                          {permission.label}
                        </span>
                        <span className="mt-0.5 block text-xs leading-5 text-foreground-500">
                          {permission.description}
                        </span>
                      </span>
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </div>
  );
}